import React from "react";
import { Link } from "react-router-dom";

// items: [{ label, to }]  (last item is current page, no link)
export default function Breadcrumbs({ items, light = true }) {
  const base = light ? "text-paper/70" : "text-bark";
  const sep = light ? "text-paper/40" : "text-bark/50";
  return (
    <nav aria-label="Breadcrumb">
      <ol className={`flex flex-wrap items-center gap-2 text-sm ${base}`}>
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-2">
              {last || !item.to ? (
                <span aria-current="page" className={light ? "text-white" : "text-ink"}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="hover:underline underline-offset-4">
                  {item.label}
                </Link>
              )}
              {!last && <span className={sep}>/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.label,
    ...(item.to ? { item: `https://www.cambridgecarpenter.co.uk${item.to}` } : {}),
  })),
});
